document.addEventListener("DOMContentLoaded", () => {

  // ==========================
  // ELEMENTS
  // ==========================

  const widget = document.getElementById("mf-widget");
  const widgetClose = document.getElementById("mf-widget-close");
  const openBtn = document.getElementById("mf-open");

  const modal = document.getElementById("mf-modal");
  const modalClose = document.getElementById("mf-close");
  const overlay = document.getElementById("mf-overlay");

  const muteBtn = document.getElementById("mf-mute");
  const playBtn = document.getElementById("mf-play");

  const cartBtn = document.querySelector(".mf-cart");

  if (!widget || !modal) return;

  const modalVideo = modal.querySelector("video");

  // ==========================
  // OPEN MODAL
  // ==========================

  openBtn?.addEventListener("click", () => {

      modal.classList.add("active");

      document.body.style.overflow = "hidden";

      if(modalVideo){

          modalVideo.currentTime = 0;

          modalVideo.play();

          playBtn.innerHTML = "⏸";

      }

  });

  // ==========================
  // CLOSE MODAL
  // ==========================

  function closeVideo(){

      modal.classList.remove("active");

      document.body.style.overflow = "";

      if(modalVideo){

          modalVideo.pause();

      }

  }

  modalClose?.addEventListener("click", closeVideo);

  overlay?.addEventListener("click", closeVideo);

  document.addEventListener("keydown",(e)=>{

      if(e.key==="Escape"){

          closeVideo();

      }

  });

  // ==========================
  // HIDE FLOATING WIDGET
  // ==========================

  widgetClose?.addEventListener("click",(e)=>{

      e.stopPropagation();

      widget.style.display="none";

  });

  // ==========================
  // PLAY / PAUSE
  // ==========================

  playBtn?.addEventListener("click",()=>{

      if(!modalVideo) return;

      if(modalVideo.paused){

          modalVideo.play();

          playBtn.innerHTML="⏸";

      }else{

          modalVideo.pause();

          playBtn.innerHTML="▶";

      }

  });

  // ==========================
  // MUTE / UNMUTE
  // ==========================

  muteBtn?.addEventListener("click",()=>{

      if(!modalVideo) return;

      modalVideo.muted=!modalVideo.muted;

      muteBtn.innerHTML=modalVideo.muted ? "🔇" : "🔊";

  });

  // ==========================
  // AJAX ADD TO CART
  // ==========================

  cartBtn?.addEventListener("click",()=>{

      const variantId=cartBtn.dataset.variant;

      fetch("/cart/add.js",{

          method:"POST",

          headers:{

              "Content-Type":"application/json"

          },

          body:JSON.stringify({

              id:variantId,

              quantity:1

          })

      })

      .then(res=>res.json())

      .then(()=>{

          cartBtn.innerHTML="✓ Added";

          setTimeout(()=>{

              cartBtn.innerHTML="Add To Cart";

          },1500);

      })

      .catch(()=>{

          alert("Unable to add product.");

      });

  });

});